import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createEntityAdapter } from '@reduxjs/toolkit'
import { useWatch, useFormContext } from 'react-hook-form'
import { getAllDatasets } from '../../../../redux/slices'
import { AnalyzerDropdown } from '../components/AnalyzerDropdown'
import { DefaultState } from '../../../../types'

export interface DatasetMinimal {
  id: number | string
  name: string
  type: 'dynamic' | 'static' | string
}

const DatasetSelectorWrapper = () => {
  const dispatch = useDispatch()
  const { control } = useFormContext()
  const selectedType = useWatch({ control, name: 'type' }) || 'Manual'

  useEffect(() => {
    dispatch(getAllDatasets())
  }, [dispatch])

  const datasets = createEntityAdapter<DatasetMinimal>()
    .getSelectors()
    .selectAll(useSelector((state: DefaultState) => state.datasets))

  const filtered = datasets.filter(
    (d) => d.type === (selectedType === 'Ingress' ? 'dynamic' : 'static')
  )

  const options = filtered.map((d) => ({
    label: d.name,
    value: d.id
  }))

  return (
    <AnalyzerDropdown
      name="datasetId"
      label="Dataset"
      options={options}
      isRequired={true}
    />
  )
}

export default DatasetSelectorWrapper
